/**
 * 基础状态枚举
 */
export enum BasicStatus {
  DISABLE = 0,
  ENABLE = 1,
}

/**
 * API 响应状态枚举
 */
export enum ResultStatus {
  SUCCESS = 0,
  ERROR = -1,
  TIMEOUT = 408,
}

/**
 * 存储键枚举
 */
export enum StorageEnum {
  UserInfo = "userInfo",
  UserToken = "userToken",
  Settings = "settings",
  I18N = "i18nextLng",
}

/**
 * 主题模式枚举
 */
export enum ThemeMode {
  Light = "light",
  Dark = "dark",
}

/**
 * 主题布局枚举
 */
export enum ThemeLayout {
  Vertical = "vertical",
  Horizontal = "horizontal",
  Mini = "mini",
}

/**
 * 主题颜色预设枚举
 */
export enum ThemeColorPresets {
  Default = "default",
  Cyan = "cyan",
  Purple = "purple",
  Blue = "blue",
  Orange = "orange",
  Red = "red",
}

/**
 * 语言枚举
 */
export enum LocaleEnum {
  en_US = "en_US",
  zh_CN = "zh_CN",
}

/**
 * 多标签操作枚举
 */
export enum MultiTabOperation {
  FULLSCREEN = "fullscreen",
  REFRESH = "refresh",
  CLOSE = "close",
  CLOSEOTHERS = "closeOthers",
  CLOSEALL = "closeAll",
  CLOSELEFT = "closeLeft",
  CLOSERIGHT = "closeRight",
}

/**
 * 权限类型枚举
 */
export enum PermissionType {
  GROUP = 0,
  CATALOGUE = 1,
  MENU = 2,
  COMPONENT = 3,
}

/**
 * HTML 数据属性枚举
 */
export enum HtmlDataAttribute {
  ColorPalette = "data-color-palette",
  ThemeMode = "data-theme-mode",
}

/**
 * 优先级枚举
 */
export enum Priority {
  Low = "low",
  Medium = "medium",
  High = "high",
  Urgent = "urgent",
}
